import { addDays } from 'date-fns/addDays'
import { addHours } from 'date-fns/addHours'
import { addWeeks } from 'date-fns/addWeeks'

export const getMuteUntil = (
  muteFor: string,
  days: number,
  hours: number,
  weeks: number,
) => {
  const today = new Date()

  switch (muteFor) {
    case '8hrs': {
      return addHours(today, 8)
    }
    case '1day': {
      return addDays(today, 1)
    }
    case '1week': {
      return addWeeks(today, 1)
    }
    case 'custom': {
      if (weeks || days || hours) {
        return addWeeks(addDays(addHours(today, hours), days), weeks)
      }
    }
  }

  return undefined
}
